/* tslint:disable */
import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface QuestionnaireArchivePostParams {
  questionnaireGuid: string;
}

export function questionnaireArchivePost(
  http: HttpClient,
  rootUrl: string,
  params: QuestionnaireArchivePostParams,
  headers: HttpHeaders,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, questionnaireArchivePost.PATH, 'post');

  for (const headerKey of headers.keys()) {
    rb.header(headerKey, headers.get(headerKey));
  }

  if (params) {
    rb.path('questionnaireGuid', params.questionnaireGuid, {
      style: 'simple',
    });
  }

  return http
    .request(rb.build({ responseType: 'json', accept: '*/*', context }))
    .pipe(
      filter(
        (r: unknown): r is HttpResponse<unknown> => r instanceof HttpResponse,
      ),
      map((r: HttpResponse<unknown>) => r as StrictHttpResponse<void>),
    );
}

questionnaireArchivePost.PATH =
  '/api/v1/questionnaires/{questionnaireGuid}/archive';
